'use client'
import { useTranslations } from 'next-intl'
import { useEffect, useMemo, useState } from 'react'
import { APIClient } from '../helpers/api_helper'
import Select from 'react-select';
import Link from 'next/link'
import {types} from '../helpers/utils'
import { useLocale } from 'use-intl'

export default function ClientRealEstateForSaleComponent() {
  const t = useTranslations('')
  const currentLanguage = useLocale();

  const api = useMemo(() => new APIClient(), []);

  const [formData, setFormData]: any = useState({
    category: null,
    category_type: null,
    type: 'Have property for sell',
    name: "",
    phone: "",
    message: "",
  });
  const [initialData, setInitialData]: any = useState({
    categories: [],
    types: [],
    branches: [],
    regions: [],
    zones: [],
    streets: [],
  });

  let transformObjectData: (data: any) => { types: any; categories: any }
  transformObjectData = (data: any) => {
    const { categories } = data

    const transformedTypesData = types.map((item: any) => ({
      value: item.id,
      label: t(item.label)
    }))
    const transformedCategoriesData = categories.map((item: any) => ({
      value: item.id,
      label: item.translations[currentLanguage].name
    }))

    return {
      types: transformedTypesData,
      categories: transformedCategoriesData
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      api.get(`/initial-information/`).then(data => {
        setInitialData(transformObjectData(data));
      });
    };

    fetchData();
  }, [api, transformObjectData]);

  const [categoryError, setCategoryError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [requestSellNameError, setRequestSellNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [collapsedRows, setCollapsedRows] = useState([true, true, true, true]);

  const toggleRowCollapse = (index:number) => {
    setCollapsedRows((prev) =>
      prev.map((collapsed, i) => (i === index ? !collapsed : collapsed))
    );
  };

  const handleInputChange = (e:any) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event:any) => {
    event.preventDefault();

    let valid = true;

    if (!formData.category) {
      setCategoryError(t("Category should be selected"));
      valid = false;
    } else {
      setCategoryError("");
    }

    if (!formData.type) {
      setTypeError(t("Type should be selected"));
      valid = false;
    } else {
      setTypeError("");
    }

    if (!formData.name) {
      setRequestSellNameError(t("Name, surname should not be empty"));
      valid = false;
    } else {
      setRequestSellNameError("");
    }

    if (!formData.phone) {
      setPhoneError(t("Phone should not be empty"));
      valid = false;
    } else {
      setPhoneError("");
    }

    if (!valid) {
      return;
    }

    const requestData = new FormData();

    for (const key in formData) {
      if (typeof formData[key] === 'object') {
        for (const subKey in formData[key]) {
          requestData.append(`${key}[${subKey}]`, formData[key][subKey]);
        }
      } else {
        requestData.append(key, formData[key]);
      }
    }

    try {
      // const data = formData
      // data.category_type = typeAlias[formData.type]
      const response = await api.create(`/contact-us`, formData)

      if (response) {
        window.location.href = `/${currentLanguage}/thank-you`;
      }

    } catch (error) {
      console.error("Error submitting form", error);
    }
  };
  const handleSelectChange = (name: string) => async (e: any) => {
    let value = e.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  }

  return (
    <main>
      <section className="simpleContainer">
        <div className="container-sections real-estate-for-sale-header-text">
          <h1>{t('Have a real estate for sale')}</h1>
        </div>

        <div className="simpleContainer real-estate-for-sale-container">
          <div className="row justify-content-md-center">
            <div className="col-md-6">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group text-left">
                      <Select
                        value={
                          initialData.categories.filter((option: any) => {
                            return option.value === formData.category;
                          })
                        }
                        onChange={handleSelectChange('category')}
                        options={initialData.categories}
                        placeholder={t('Select placeholder')}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: '#e8e8e8',
                            fontSize: '14px',
                            color: '#212529',
                            borderRadius: '8px',
                            minHeight: '30px',
                          }),
                        }}
                      />
                      {/*<Select*/}
                      {/*    value={*/}
                      {/*        categoriesTrans.filter(option => {*/}
                      {/*            return formData.category === option.id;*/}
                      {/*        })*/}
                      {/*    }*/}
                      {/*    className="custom-select-box-design"*/}
                      {/*    onChange={handleSelectChange('category')}*/}
                      {/*    options={categoriesTrans}*/}
                      {/*    placeholder={t('Category')}*/}
                      {/*    styles={{*/}
                      {/*        control: (baseStyles, state) => ({*/}
                      {/*            ...baseStyles,*/}
                      {/*            borderColor: '#e8e8e8',*/}
                      {/*            fontSize: '14px',*/}
                      {/*            color: '#212529',*/}
                      {/*            borderRadius: '8px',*/}
                      {/*        }),*/}
                      {/*    }}*/}
                      {/*/>*/}
                      {categoryError &&
                        <small className="text-danger">{categoryError}</small>}
                    </div>

                    <div className="form-group text-left mt-3">
                      <input className="form-control" type="text" name="name" id="name"
                             placeholder={t('Name, Surname')} value={formData.name}
                             onChange={handleInputChange}/>
                      <small className="text-danger"></small>
                      {requestSellNameError &&
                        <small className="text-danger">{requestSellNameError}</small>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group text-left">
                      <Select
                        value={
                          initialData.types.filter((option: any) => {
                            return option.value === formData.category_type;
                          })
                        }
                        onChange={handleSelectChange('category_type')}
                        options={initialData.types}
                        placeholder={t('Select placeholder')}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: '#e8e8e8',
                            fontSize: '14px',
                            color: '#212529',
                            borderRadius: '8px',
                            minHeight: '30px',
                          }),
                        }}
                      />
                      {/*<Select*/}
                      {/*    value={*/}
                      {/*        types.filter(option => {*/}
                      {/*            return formData.category_type === option.id;*/}
                      {/*        })*/}
                      {/*    }*/}
                      {/*    className="custom-select-box-design"*/}
                      {/*    onChange={handleSelectChange('category_type')}*/}
                      {/*    options={types}*/}
                      {/*    placeholder={t('Type')}*/}
                      {/*    styles={{*/}
                      {/*        control: (baseStyles, state) => ({*/}
                      {/*            ...baseStyles,*/}
                      {/*            borderColor: '#e8e8e8',*/}
                      {/*            fontSize: '14px',*/}
                      {/*            color: '#212529',*/}
                      {/*            borderRadius: '8px',*/}
                      {/*            minHeight: '30px',*/}
                      {/*        }),*/}
                      {/*    }}*/}
                      {/*/>*/}
                      {typeError && <small className="text-danger">{typeError}</small>}
                    </div>

                    <div className="form-group text-left">
                      <div className="input-group">
                        <input className="form-control" name="phone" type="text" id="phone"
                               placeholder={t('Tel')} value={formData.phone}
                               onChange={handleInputChange}/>
                        <small className="text-danger"></small>
                      </div>
                      {phoneError && <small className="text-danger">{phoneError}</small>}
                    </div>
                  </div>
                </div>

                <div className="form-group mt-3">
                                        <textarea className="form-control" name="message"
                                                  placeholder={t('Additional information')} rows={6}
                                                  value={formData.message} onChange={handleInputChange}></textarea>
                  <small className="text-danger"></small>
                </div>

                <div className="form-group">
                  <button type="submit"
                          className="btn submit-contact-btn">{t('Send Request')}</button>
                </div>

                <div className="form-group g-recaptcha-container">
                  <div className="g-recaptcha" data-sitekey=""></div>
                </div>
              </form>
            </div>
          </div>

          <div className="row justify-content-md-center mt-4">
            <div className="col-md-9 text-start">
              <div>
                <div>
                  <h4 className="mt-3">{t('have_estate_for_sale_heading')}</h4>
                  <p className="mt-3">{t('have_estate_for_sale_description')}</p>
                  <p className="mt-3 mb-3">{t('have_estate_for_sale_description2')}</p>
                </div>
                <div className="video-row" onClick={() => toggleRowCollapse(0)}>
                  <div className="video-row-left">
                    <div className="video-block-source">
                      <span>{t('have_estate_for_sale_q_1')}</span>
                    </div>
                  </div>
                  <div className="video-row-right">
                    <i className={`fa fa-play ${collapsedRows[0] ? '' : 'fa-rotate-90'}`}></i>
                  </div>
                </div>

                {
                  !collapsedRows[0] &&
                  <div className="faq-description">
                    <div className="video-row-left">
                      <div className="video-block-source">
                        <ul>
                          <li className="mt-2">
                            <b>{t('have_estate_for_sale_a_1_1_h')}</b>
                            <span> {t('have_estate_for_sale_a_1_1_t')}</span>
                          </li>
                          <li className="mt-2">
                            <b>{t('have_estate_for_sale_a_1_2_h')}</b>
                            <span> {t('have_estate_for_sale_a_1_2_t')}</span>
                          </li>
                          <li className="mt-2">
                            <b>{t('have_estate_for_sale_a_1_3_h')}</b>
                            <span> {t('have_estate_for_sale_a_1_3_t')}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                }

                <div className="video-row" onClick={() => toggleRowCollapse(1)}>
                  <div className="video-row-left">
                    <div className="video-block-source">
                      <span>{t('have_estate_for_sale_q_2')}</span>
                    </div>
                  </div>
                  <div className="video-row-right">
                    <i className={`fa fa-play ${collapsedRows[1] ? '' : 'fa-rotate-90'}`}></i>
                  </div>
                </div>

                {
                  !collapsedRows[1] &&
                  <div className="faq-description">
                    <div className="video-row-left">
                      <div className="video-block-source">
                        <p>{t('have_estate_for_sale_a_2')}</p>
                      </div>
                    </div>
                  </div>
                }

                <div className="video-row" onClick={() => toggleRowCollapse(2)}>
                  <div className="video-row-left">
                    <div className="video-block-source">
                      <span>{t('have_estate_for_sale_q_3')}</span>
                    </div>
                  </div>
                  <div className="video-row-right">
                    <i className={`fa fa-play ${collapsedRows[2] ? '' : 'fa-rotate-90'}`}></i>
                  </div>
                </div>

                {
                  !collapsedRows[2] &&
                  <div className="faq-description">
                    <div className="video-row-left">
                      <div className="video-block-source">
                        <p>{t('have_estate_for_sale_a_3')}</p>
                      </div>
                    </div>
                  </div>
                }

                <div className="video-row" onClick={() => toggleRowCollapse(3)}>
                  <div className="video-row-left">
                    <div className="video-block-source">
                      <span>{t('have_estate_for_sale_q_4')}</span>
                    </div>
                  </div>
                  <div className="video-row-right">
                    <i className={`fa fa-play ${collapsedRows[3] ? '' : 'fa-rotate-90'}`}></i>
                  </div>
                </div>

                {
                  !collapsedRows[3] &&
                  <div className="faq-description">
                    <div className="video-row-left">
                      <div className="video-block-source">
                        <p>{t('have_estate_for_sale_a_4')}</p>
                      </div>
                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
